import React from 'react';

const Assistenza = () => {
  return (
    <svg
      version="1.1"
      id="assistenza_icon"
      xmlns="http://www.w3.org/2000/svg"
      xlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 42 42"
      style="enable-background:new 0 0 42 42;"
      space="preserve"
      style={{
        fill: 'none',
        stroke: 'currentColor',
        strokeWidth: 2,
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
        strokeMiterlimit: 22.9256,
        verticalAlign: 'middle',
      }}
    >
      <path d="M23.47,37.41c2.59-0.39,5.22-1.29,6.99-3.06c2.19-2.19,3.9-5.91,3.9-9.24V13.8c0-3.33-1.71-6.7-3.9-8.89 C28.26,2.71,24.89,1,21.56,1H19.9c-3.33,0-6.7,1.71-8.89,3.9c-2.19,2.19-3.9,5.57-3.9,8.89v11.32" />
      <path d="M6.71,25.29c-3.14-0.24-5.62-3.04-5.62-6.45c0-3.41,2.48-6.21,5.62-6.45 M34.72,25.29 c3.14-0.24,5.62-3.04,5.62-6.45c0-3.41-2.48-6.21-5.62-6.45" />
      <path d="M20.72,34.7c1.51,0,2.74,1.23,2.74,2.74c0,1.51-1.23,2.74-2.74,2.74s-2.74-1.23-2.74-2.74 C17.97,35.93,19.2,34.7,20.72,34.7L20.72,34.7z" />
      <path d="M6.87,12.72c4.02-0.82,7.4-3.4,9.3-6.9C18.66,8.4,22.15,10,26.01,10c2.45,0,4.75-0.64,6.74-1.77" />
    </svg>
  );
};

export default Assistenza;
